export type StandardError = {
  error?: string;
  description?: string;
  requestId?: string;
  traceId?: string;
  responseCode?: number;
};

export enum ApiErrors {
  Unauthorized = 'unauthorized',
  ResourceNotFound = 'resource_not_found',
  Conflict = 'conflict',
  TemporarilyUnavailable = 'temporarily_unavailable',
  AccessDenied = 'access_denied',
}

export enum ApiSubErrors {
  InsufficientScope = 'insufficient_scope',
  ProductAlreadyExists = 'product already exists for requester',
  LimitReached = 'limit reached',
  TrafficBlocked = 'traffic blocked',
  ResourceLimitReached = 'resource limit reached',
  CannotInstallProduct = 'cannot install product in this organization',
}

export enum ValidationErrors {
  Required = 'required',
  InvalidEmail = 'incorrect_email',
  InvalidPhoneNumber = 'incorrect_phone_number',
  InvalidUrl = 'incorrect_url',
  InvalidNameValue = 'incorrect_name',
  TooShort = 'minLength',
  TooLong = 'maxLength',
}

export type ValidationError = {
  type: ValidationErrors;
  minLength?: number;
  maxLength?: number;
};
